import { IDestinationCountry } from '@nibtravel/shared/util/models';

/**
 * @description
 * Abstraction that converts the IDestinationCountry array into an object that
 * is readable on the autocomplete and dropdown components. They are not strongly
 * typed to avoid unnecessary injection of an entire library for the its interface.
 *
 * We need to see if there's a better way, but for now, prioritizing bundle size.
 *
 * In addition, moved this to its own file so it can also be used for unit testing
 */
export function toSelectObject(
  countries: IDestinationCountry[]
): Record<string, any>[] {
  return countries.map((country: IDestinationCountry) => ({
    text: country.name,
    value: country.code,
    index: country.code,
    aliases: country.aliases,
    sentenceName: country.sentenceName,
  }));
}
